<div class="create-proposal-scope-product-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon>inventory_2</mat-icon>
    </div>
    <div class="header-content">
      <h2 class="dialog-title">Create Quick Product</h2>
    </div>
    <button class="close-btn" (click)="close()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="row m-auto popup-body popup-convert-wrapper align-items-center" [formGroup]="proposalScopeProductForm">
    <div class="col-md-6 mt-2">
      <label for="manufacturer">
        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center">Manufacturer *</div>
          <div class="toggles">
            <mat-slide-toggle formControlName="is_vendor" (change)="createOrSelecteVendor($event)">Is vendor</mat-slide-toggle>
          </div>
        </div>

      </label>
      <div class="d-flex flx-11">
        <ng-select
          class="col-11"
          id="manufacturer"
          [items]="manufacturers"
          placeholder="Select manufacturer"
          [closeOnSelect]="true"
          formControlName="manufacturer"
          bindLabel="name"
          style="height: 60px"
          (change)="setVendorOnchange($event)"
          >
        </ng-select>
        <span class="plus-icon-select col-1" (click)="onAddManufacturer($event)">+</span>
      </div>
      <app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'manufacturer'"></app-validation-error>
    </div>
    <div class="col-md-6 mt-2">
      @if (!isVendor) {
        <label>Vendors *</label>
        <div class="d-flex flx-11">
          <!-- <ng-select
          class="col-11"
          id="vendor"
          [items]="vendors"
          placeholder="Select vendor"
          [closeOnSelect]="true"
          formControlName="vendor"
          bindLabel="name"
          style="height: 60px"
          (change)="setMarkup($event)"
          >
        </ng-select> -->
        <app-scrollable-search-field
          style="width: 100%;"
          id="vendor_dropdown_id"
          [dataService]="vendorDataService"
          [dataServiceFunctionName]="'search'"
          [sortBy]="'id'"
          [sortOrder]="'desc'"
          [searchPlaceHolder]="'Select Vendor'"
          [labelKey]="'name'"
          [keyNameToShowWhenSelected]="'name'"
          [inputVal]="proposalScopeProductForm.get('vendor')?.value ? proposalScopeProductForm.get('vendor')?.value?.name : ''"
          [addButtonLabel]="'Add vendor'"
          [formDataMapper]="'all'"
          (selectedValueChange)="setMarkup($event)"
          (addButtonCallback)="createVendor()"
          [markCtrlTouched]="proposalScopeProductForm.get('vendor')?.touched"
          [showError]="false"
          >
        </app-scrollable-search-field>
        <span class="plus-icon-select" (click)="this.createVendor()">+</span>
      </div>
      <app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'vendor'"></app-validation-error>
    }
  </div>
  <!--<div class="col-md-6 mt-2">
  <label for="category">Type Of Product </label>
  <div class="d-flex flx-11">
    <ng-select
      class="col-11"
      id="category"
      [items]="productTypes"
      placeholder="Select product type "
      [closeOnSelect]="true"
      formControlName="category"
      bindLabel="name"
      style="height: 60px"
      >
    </ng-select>
    &lt;!&ndash;        <mat-form-field appearance="fill">&ndash;&gt;
    &lt;!&ndash;          <mat-select id="category" formControlName="category">&ndash;&gt;
    &lt;!&ndash;            <mat-option [value]="">Select Categories</mat-option>&ndash;&gt;
    &lt;!&ndash;            <mat-option *ngFor="let productType of productTypes" [value]="productType.id">{{ productType?.name}}</mat-option>&ndash;&gt;
  &lt;!&ndash;          </mat-select>&ndash;&gt;
&lt;!&ndash;        </mat-form-field>&ndash;&gt;
&lt;!&ndash;        <span class="plus-icon-select">+</span>&ndash;&gt;
</div>
<app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'category'"></app-validation-error>
</div>
<div class="col-md-6 mt-2">
  <label for="scope">scopes</label>
  <div class="d-flex flx-11">

    <ng-select
      class="col-11"
      id="scope"
      [items]="scopes"
      [multiple]="true"
      placeholder="Select scopes"
      [closeOnSelect]="true"
      formControlName="scopes"
      bindLabel="name"
      style="height: 60px"
      >
    </ng-select>
  </div>
  <app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'category'"></app-validation-error>
</div>
<div class="col-md-6 mt-2">
  <span class="prefix">https://</span>
  <input type="text" id="productUrl" class="w-100" (blur)="removeHttp()" formControlName="productUrl"
    class="form-control" placeholder="Type here" name="markUp">
  <app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'productUrl'"></app-validation-error>
</div>-->
<!--<div class="col-md-6 mt-2">
<label for="name">Name</label>
<input type="text" id="name" formControlName="name" class="form-control" placeholder="Type here">
<app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'name'"></app-validation-error>
</div>-->

<div class="form-group col-md-12 mt-2">
  <div class="d-flex justify-content-between">
    <label for="name" class="custom_label prefix"> Model Number * </label>
    <span class="postfix">
      <mat-slide-toggle labelPosition="before" formControlName="isManufacturerPrefixUse" class="toggle_switch">Use Manufacturer Prefix</mat-slide-toggle>
    </span>
  </div>
  <div class="input-box">
    @if (proposalScopeProductForm.get('isManufacturerPrefixUse')?.value) {
      <span class="prefix">{{proposalScopeProductForm.get('manufacturer')?.value?.prefix}}</span>
    }
    <input type="text"  id="name" formControlName="name" class="form-control" placeholder="Product Name" name="name">
  </div>
  <app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'name'"></app-validation-error>
</div>

<div class="col-md-6 mt-2">
  <label for="unitPrice">Unit Price *</label>
  <div class=" input-boxs input_with_icons">
    <span class="icon_wraps"><img src="../../../../assets/img/dollar_sign.svg" alt="icon"></span>
    <input currencyMask [max]="99999999.99" [options]="currencyMaskOptions"  id="unitPrice" formControlName="unitPrice" class="form-control" placeholder="Type here" autocomplete="off">
  </div>
  <app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'unitPrice'"></app-validation-error>
</div>

<!--<div class="col-md-6 mt-2">
<label for="measurement">Unit of Measurement *</label>
<div class="d-flex flx-11">
  <ng-select
    class="col-11"
    id="measurement"
    [items]="measurementUnits"
    placeholder="Select UOM"
    [closeOnSelect]="true"
    formControlName="measurement"
    bindLabel="name"
    style="height: 60px"
    >
  </ng-select>
  <span class="plus-icon-select" (click)="onAddUnitOfMeasurement($event)">+</span>
</div>
<app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'category'"></app-validation-error>
</div>-->
<div class="col-md-6 mt-2">
  <label for="markup">Markup *</label>
  <div class=" input-boxs input_with_icons">
    <span class="icon_wraps">%</span>
    <input currencyMask [max]="99999999.99" [options]="currencyMaskOptions"  id="markup" formControlName="profit_markup" class="form-control" placeholder="Type here" autocomplete="off">
  </div>
  <app-validation-error [formGroup]="proposalScopeProductForm"  [controlName]="'profit_markup'" ></app-validation-error>
</div>

<!--<div class="col-md-6 mt-2">

<div class="form-group ">
  <mat-slide-toggle formControlName="productStatus" [checked]="true">Product Status</mat-slide-toggle>
  &lt;!&ndash;<mat-slide-toggle formControlName="vendorMultiplier">Vendor Multiplier</mat-slide-toggle>&ndash;&gt;

</div>
</div>-->
<div class="col-md-12 mt-2">
  <label for="description">Description</label>
  <textarea name="description" id="description" formControlName="description" rows="4" placeholder="Type here"></textarea>
  <!--<app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'vendor'"></app-validation-error>-->
</div>
</div>

<!-- Dialog Footer -->
<div class="dialog-footer">
  <button class="btn-cancel" (click)="close()">
    <mat-icon>close</mat-icon>
    Cancel
  </button>
  <button class="btn-submit" (click)="save()">
    <mat-icon>check_circle</mat-icon>
    Save
  </button>
</div>

<div style="display: none">
  <mat-stepper #stepper>
    <mat-step>
      <form [formGroup]="productName">
        <div class="step">
          <div class="heading">
            <h2>What is Product Model Number?</h2>
          </div>

          <div class="row input-fields">
            <div class="col-md-12 mt-2">
              <label for="name">Name *</label>
              <input type="text" id="name" formControlName="name" class="form-control" placeholder="Type here">
              <app-validation-error [formGroup]="productName" [controlName]="'name'"></app-validation-error>
            </div>

            <div class="col-md-6">
              <button class="btn btn-convert-invoice" (click)="close()">Close</button>
            </div>
            <div class="col-md-6">
              <button class="btn btn-convert" (click)="onClickMoveNext(this.productName)">Next</button>
            </div>
          </div>
        </div>
      </form>
    </mat-step>
    <mat-step >
      <form [formGroup]="productDetail">
        <div class="step">
          <div class="heading">
            <h2>Who is the vendor?</h2>
          </div>

          <div class="row input-fields">
            <div class="col-md-12 mt-2">
              <app-search-field
                [searchAbleDataService]="vendorDataService"
                [searchAbleFunctionName]="'searchItems'"
                [searchAbleParams]="{vendor_id: '', search: ''}"
                [labelKey]="'name'"
                (onSelectValue)="onItemSelect($event)"
                (onNoSelection)="onConfirmation($event)"
                [defaultSearchValue]="'name'"
                [searchPlaceHolder]="'Type to search Vendor'">
              </app-search-field>
              <!--                <app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'name'"></app-validation-error>-->
            </div>

            <div class="form-row">
              <div class="form-group col-12">
                <mat-slide-toggle formControlName="is_manufacturer">Is Manufacturer</mat-slide-toggle>
              </div>
            </div>

            <div class="col-md-12 mt-2">
              <label for="vendor_prefix">Vendor Prefix *</label>
              <input type="text" id="vendor_prefix" formControlName="vendor_prefix" class="form-control" placeholder="Type here">
              <app-validation-error [formGroup]="productDetail" [controlName]="'vendor_prefix'"></app-validation-error>
            </div>

            <div class="col-md-12 mt-2">
              <label for="manufacturer">Select Manufacturer *</label>
              <ng-select
                id="manufacturer"
                formControlName="manufacturer"
                [items]="[{id:1,name:'Manufacturer 1'},{id:2,name:'Manufacturer 2'},{id:3,name:'Manufacturer 3'},]"
                placeholder="Select manufacturer"
                [closeOnSelect]="true"
                bindLabel="name"
                style="height: 60px"
                >
              </ng-select>
              <app-validation-error [formGroup]="productDetail" [controlName]="'manufacturer'"></app-validation-error>
            </div>

            <div class="col-md-6">
              <button class="btn btn-convert-invoice" matStepperPrevious>Back</button>
            </div>
            <div class="col-md-6">
              <button class="btn btn-convert" (click)="onClickMoveNext(this.productDetail)">Next</button>
            </div>
          </div>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <form [formGroup]="productPrice">
        <div class="step">
          <div class="heading">
            <h2>What is Unit Price/Markup?</h2>
          </div>

          <div class="row input-fields">
            <div class="col-md-12 mt-2">
              <label for="unit_price">Unit Price *</label>
              <input currencyMask [max]="99999999.99" [options]="currencyMaskOptions" id="unit_price" formControlName="unit_price" class="form-control" placeholder="Type here" autocomplete="off">
              <app-validation-error [formGroup]="productPrice" [controlName]="'unit_price'"></app-validation-error>
            </div>

            <div class="col-md-12 mt-2">
              <label for="markup">Markup *</label>
              <input currencyMask [max]="99999999.99" [options]="currencyMaskOptions"  id="markup" formControlName="markup" class="form-control" placeholder="Type here" autocomplete="off">
              <app-validation-error [formGroup]="productPrice" [controlName]="'markup'"></app-validation-error>
            </div>

            <div class="col-md-6">
              <button class="btn btn-convert-invoice" matStepperPrevious>Back</button>
            </div>
            <div class="col-md-6">
              <button class="btn btn-convert" (click)="onClickMoveNext(this.productPrice)">Next</button>
            </div>
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step>
      <form [formGroup]="description">
        <div class="step">
          <div class="heading">
            <h2>What is Description?</h2>
          </div>

          <div class="row input-fields">
            <div class="col-md-12 mt-2">
              <label for="description">Description</label>
              <textarea name="description" id="description" formControlName="description" rows="4" placeholder="Type here"></textarea>
              <app-validation-error [formGroup]="description" [controlName]="'vendor'"></app-validation-error>
            </div>

            <div class="col-md-6">
              <button class="btn btn-convert-invoice" matStepperPrevious>Back</button>
            </div>
            <div class="col-md-6">
              <button class="btn btn-convert" >Save</button>
            </div>
          </div>
        </div>
      </form>
    </mat-step>
  </mat-stepper>
</div>
</div>
